import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const EditInputField = ({
  label,
  name,
  value,
  onChange,
  rows,
  type = false,
  disabled,
  options = [],
  step,
  required,
  loading,
}) => {
  if (type === "select" || type === "radio") {
    return (
      <div className="md:mb-4 mb-4">
        <label className="block text-gray-500 font-bold mb-2">{label}</label>
        <select
          name={name}
          className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500 disabled:cursor-not-allowed"
          id="assigned-email-select"
          value={value}
          onChange={onChange}
          disabled={disabled || false}
          required={required}
        >
          <option value="">Select {label}</option>
          {options.map((data, i) => (
            <option key={i} value={data.value}>
              {data.label}
            </option>
          ))}
        </select>
      </div>
    );
  } else if (type === "textarea") {
    return (
      <div className="md:mb-4 mb-4">
        <label className="block text-gray-500 font-bold mb-2">{label}</label>
        <textarea
          name={name}
          value={value}
          rows={rows}
          disabled={disabled || false}
          onChange={onChange}
          required={required}
          className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500 disabled:cursor-not-allowed"
        />
      </div>
    );
  } else if (type === "checkbox") {
    return (
      <div className="">
        <label className="block text-gray-500 font-bold  mb-2">{label}</label>
        <div className="relative inline-flex items-center">
          <input
            id={name}
            name={name}
            type="checkbox"
            onChange={onChange}
            checked={value === "true"}
            className="onOffCheck peer"
          />
          <label
            htmlFor={name}
            className="absolute right-3 text-xs font-semibold text-canvas-primary peer-checked:hidden block"
          >
            NO
          </label>
          <label
            htmlFor={name}
            className="absolute left-3 text-xs font-semibold text-canvas-white peer-checked:block hidden"
          >
            YES
          </label>
        </div>
      </div>
    );
  } else if (type === "rating") {
    return (
      <div className="">
        <label className="block text-gray-500 font-bold  mb-2">{label}</label>
        <div>
          {[...Array(5)].map((_, index) => (
            <span
              key={index}
              onClick={() => onChange(index + 1)}
              className={`cursor-pointer text-3xl hover:text-yellow-500 ${index < value ? "text-yellow-500" : "text-gray-300"
                }`}
            >
              {index < value ? "★" : "☆"}
            </span>
          ))}
        </div>
        <input type="hidden" name="tracking_rating" value={value} />
      </div>
    );
  } else if (type === "date") {
    return (
      <div className="md:mb-4 mb-4">
        <label className="block text-gray-500 font-bold mb-2">
          {label} {loading ? "Loading ..." : ""}
        </label>
        <DatePicker
          showIcon
          selected={value}
          onChange={(date) => onChange(date)}
          disabled={disabled || false}          
          required={required}
          className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500 disabled:cursor-not-allowed"
        />
      </div>
    );
  } else {
    return (
      <div className="md:mb-4 mb-4">
        <label className="block text-gray-500 font-bold mb-2">
          {label} {loading ? "Loading ..." : ""}
        </label>
        <input
          type={type || "text"}
          name={name}
          value={value}
          onChange={onChange}
          disabled={disabled || false}
          step={step}
          required={required}
          placeholder={label}
          className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500 disabled:cursor-not-allowed"
        />
      </div>
    );
  }
};

export default EditInputField;

export const EditNumberInput = ({
  label,
  name,
  value,
  onChange,
  min,
  max,
  step = 1,
  disabled,
  required,
  ...rest
}) => {
  const handleChange = (e) => {
    let newValue = e.target.value;

    // Allow empty input (for clearing the field)
    if (newValue === "") {
      onChange("");
      return;
    }

    newValue = Number(newValue);

    // Clamp between min and max
    if (min !== undefined && newValue < min) newValue = min;
    if (max !== undefined && newValue > max) newValue = max;

    onChange(newValue);
  };

  return (
    <div className="md:mb-4 mb-4">
      <label className="block text-gray-500 font-bold mb-2">{label}</label>
      <input
        type="number"
        name={name}
        value={value}
        onChange={handleChange}
        min={min}
        max={max}
        step={step}
        disabled={disabled || false}
        required={required}
        placeholder={label}
        className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500 disabled:cursor-not-allowed"
        {...rest}
      />
      {min !== undefined && max !== undefined && (
        <p className="text-xs text-gray-500 mt-1">
          Must be between {min} and {max}
        </p>
      )}
    </div>
  );
};
